import * as React from 'react';
import { loadActiveClassroomLocalStorage } from 'utils/commonUtils';
import { useCustomSWR } from 'utils/customHooks';
import { restAPIs } from 'utils/restAPIs';
import './index.scss'
import { ProfileCard } from 'assets/styles/commonStyle';
import { Avatar, Button } from '@mui/material';
import { SingleActivity } from 'pages/RecentActivities/styles';
import { colors } from 'assets/styles/colors';
import PrimaryButton from 'components/atoms/CustomButtons';
import { useNavigate } from 'react-router-dom';
import { fetchData } from 'utils/fetch';


const JoinRequestsApproval: React.FC = () => {

    const [accepted, setAcccepted] = React.useState<any>([]);
    const [declined, setDeclined] = React.useState<any>([]);
    const activeClassroom = loadActiveClassroomLocalStorage()
    const navigate = useNavigate();
    const { data, isLoading } = useCustomSWR(restAPIs.getJoinRequests(activeClassroom?._id));
    const requests = data?.data


    const getAcceptStatus = (item: any) => accepted.includes(item);
    const getDeclineStatus = (item: any) => declined.includes(item);

    React.useEffect(() => {
        setAcccepted([]);
        setDeclined([]);
    }, [data]);

    async function  onAcccept(id:string, item:any) {
        let params = {
          userId: id,
        };
        setAcccepted((prevAccepted:any) => [...prevAccepted, item]);
        const response = await fetchData(restAPIs.getActivateStudent(item?._id,params), navigate);
      }

     async function onDecline(id:string, item:any) {
        let params = {
          userId: id,
        };
        setDeclined((prevDeclined:any) => [...prevDeclined, item]);
        const response = await fetchData(restAPIs.getDeclineStudent(item?._id,params), navigate);
      }

    if (requests?.length == 0||isLoading) return null

    return (
        <div className='join_requests_approval'>
            <h4 className='header' style={{ textAlign: 'left' }}>Join Requests ({requests?.length})</h4>
            {requests?.map((item: any, index: any) => {
                return (
                    <div className='__list' key={index} >
                        <SingleActivity key={index}>
                            <ProfileCard style={{ alignItems: 'center' }}>
                                <Avatar onClick={() => navigate(`/user-profile/${item?.userId?._id}`)} sx={{ bgcolor: '#222', width: 34, height: 34, fontSize: '14px' }} aria-label="recipe" src={item?.userId?.profilePic}>
                                    {item?.userId?.firstName?.slice(0, 1)}{item?.userId?.lastName?.slice(0, 1)}
                                </Avatar>
                                <div className='___label'>
                                    <span onClick={() => navigate(`/user-profile/${item?.userId?._id}`)}>
                                        {item?.userId?.firstName} {item?.userId?.lastName + ' '}</span>
                                    requested to join the classroom
                                    <span>{' ' + item?.classRoomName}</span>
                                    <div style={{ color: colors.tertiary }} className='___label'>{item.userId?.email
                                        ? item.userId?.email
                                        : item.userId?.phone
                                            ? item.userId?.phone
                                            : ''}</div>
                                </div>
                            </ProfileCard>
                            {getAcceptStatus(item) ?
                            <div className='requests_approval_button_container'>
                            <Button disabled variant="contained" className="requests_approval_button accept-button">
                                    Accepted
                                </Button></div>:
                                getDeclineStatus(item) ? 
                                <div className='requests_approval_button_container'>
                                <Button disabled variant="contained" className="requests_approval_button decline-button">
                                    Declined
                                </Button></div>:
                            <div className="buttons-container">
                                <Button onClick={() => onAcccept(item.userId._id, item)} variant="contained" className="requests_approval_button accept-button">
                                    Accept
                                </Button>
                                <Button onClick={() => onDecline(item.userId._id, item)} variant="contained" className="requests_approval_button decline-button">
                                    Decline
                                </Button>
                            </div>}
                        </SingleActivity>
                    </div>
                );
            })}
        </div>
    );
};

export default JoinRequestsApproval;